import { el } from "@dhx/ts-common/dom";
import { getCount } from "./helpers";

export function menuItem(item: any, widgetName: string, asMenuItem: boolean) {
	const getAriaAttrs = item => {
		const attrs = {
			role: "menuitem", // menuitemradio if have selected state
			"aria-disabled": item.disabled ? "true" : "false",
		};

		if (item.items) {
			attrs["aria-haspopup"] = "true";
		}

		return attrs;
	};
	const baseClass = asMenuItem ? " dhx_menu-button" : " dhx_nav-menu-button";
	return el(
		"button",
		{
			class:
				"dhx_button" +
				baseClass +
				(item.disabled ? baseClass + "--disabled" : "") +
				(item.active || item.$activeParent ? baseClass + "--active" : ""),
			disabled: item.disabled,
			dhx_id: item.id,
			type: "button",
			...getAriaAttrs(item),
		},
		asMenuItem
			? [
					item.icon || item.value || item.html
						? el("span.dhx_menu-button__block.dhx_menu-button__block--left", [
								item.icon &&
									el("span.dhx_menu-button__icon", {
										class: item.icon,
									}),
								item.html
									? el("div.dhx_menu-button__text", { ".innerHTML": item.html })
									: item.value && el("span.dhx_menu-button__text", item.value),
						  ])
						: null,
					item.count > 0 || item.hotkey || item.items
						? el("span.dhx_menu-button__block.dhx_menu-button__block--right", [
								item.count > 0 && getCount(item, " dhx_menu-button__count", false),
								item.hotkey && el("span.dhx_menu-button__hotkey", item.hotkey),
								item.items && el("span.dhx_menu-button__caret.dxi.dxi-menu-right"),
						  ])
						: null,
			  ]
			: [
					item.icon &&
						el("span.dhx_menu-button__icon", {
							class: item.icon,
						}),
					item.html
						? el("div.dhx_menu-button__text", { ".innerHTML": item.html })
						: item.value && el("span.dhx_nav-menu-button__text", item.value),
			  ]
	);
}
